export default __webpack_public_path__ + "static/media/food.ed81ddf9.jpg";